import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  heading: {
    borderBottom: `1px solid ${token.colorSplit}`,
    width: '100%',
    display: 'block',
    paddingBottom: 8
  },
  form: {
    marginTop: 24
  }
}))
